unit View.Recebimentos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewRecebimentosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbareceber_id: TLabel;
    edareceber_id: TDBEdit;
    lbvalor_bruto_recebido: TLabel;
    edvalor_bruto_recebido: TDBEdit;
    lbvalor_desconto: TLabel;
    edvalor_desconto: TDBEdit;
    lbvalor_multa: TLabel;
    edvalor_multa: TDBEdit;
    lbvalor_juros: TLabel;
    edvalor_juros: TDBEdit;
    lbvalor_outros: TLabel;
    edvalor_outros: TDBEdit;
    lbdata_recebimento: TLabel;
    eddata_recebimento: TDBEdit;
    lbplano_contas_id: TLabel;
    edplano_contas_id: TDBEdit;
    lbconta_id: TLabel;
    edconta_id: TDBEdit;
    lbmodalidade_id: TLabel;
    edmodalidade_id: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbtitulo_cobranca_id: TLabel;
    edtitulo_cobranca_id: TDBEdit;
    lbrecebimento_via_banco: TLabel;
    edrecebimento_via_banco: TDBEdit;
    lbrecebimento_venda_aprazo: TLabel;
    edrecebimento_venda_aprazo: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientRecebimentosGet: TXDataWebClient;
    XDataClientRecebimentosDelete: TXDataWebClient;
    RecebimentosDataset: TXDataWebDataSet;
    RecebimentosDatasetid: TIntegerField;
    RecebimentosDatasetaliado_id: TIntegerField;
    RecebimentosDatasetdata_base_id: TIntegerField;
    RecebimentosDatasetareceber_id: TIntegerField;
    RecebimentosDatasetvalor_bruto_recebido: TFloatField;
    RecebimentosDatasetvalor_desconto: TFloatField;
    RecebimentosDatasetvalor_multa: TFloatField;
    RecebimentosDatasetvalor_juros: TFloatField;
    RecebimentosDatasetvalor_outros: TFloatField;
    RecebimentosDatasetdata_recebimento: TDateTimeField;
    RecebimentosDatasetplano_contas_id: TIntegerField;
    RecebimentosDatasetconta_id: TIntegerField;
    RecebimentosDatasetmodalidade_id: TIntegerField;
    RecebimentosDatasetfuncionario_id: TIntegerField;
    RecebimentosDatasettitulo_cobranca_id: TIntegerField;
    RecebimentosDatasetrecebimento_via_banco: TBooleanField;
    RecebimentosDatasetrecebimento_venda_aprazo: TBooleanField;
    RecebimentosDatasetcodigo_interno: TIntegerField;
    RecebimentosDatasetexcluido: TBooleanField;
    RecebimentosDatasetinclusao: TDateTimeField;
    RecebimentosDatasetalteracao: TDateTimeField;
    RecebimentosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientRecebimentosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientRecebimentosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientRecebimentosDeleteError(Error: TXDataClientError);
    procedure RecebimentosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewRecebimentosEdit: TFViewRecebimentosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewRecebimentosEdit }

procedure TFViewRecebimentosEdit.btSaveClick(Sender: TObject);
begin
  if RecebimentosDataset.State in dsEditModes then
  begin
        RecebimentosDataset.Post;
    RecebimentosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewRecebimentosEdit.btDeleteClick(Sender: TObject);
begin
  if RecebimentosDataset.State in dsEditModes then
    RecebimentosDataset.Post;
  XDataClientRecebimentosDelete.Delete(RecebimentosDataset.EntitySetName,
    TJSObject(RecebimentosDataset.CurrentData));
end;


class function TFViewRecebimentosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewRecebimentosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewRecebimentosEdit.InsertEntity;
begin
  RecebimentosDataset.Close;
  RecebimentosDataset.SetJsonData('{}');
  RecebimentosDataset.Open;
  RecebimentosDataset.Insert;
end;

class function TFViewRecebimentosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewRecebimentosEdit(AForm).FInserting := AInserting;
    TFViewRecebimentosEdit(AForm).FId := AId;
    TFViewRecebimentosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewRecebimentosEdit(AForm).InsertEntity
    else
      TFViewRecebimentosEdit(AForm).LoadEntity;
    TFViewRecebimentosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewRecebimentosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewRecebimentosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    RecebimentosDataset.Connection.Model.DefaultSchema.FindEntityType(
      RecebimentosDataset.EntitySetName
    )
  );
  XDataClientRecebimentosGet.Get(RecebimentosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewRecebimentosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewRecebimentosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewRecebimentosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewRecebimentosEdit.XDataClientRecebimentosGetLoad(Response: TXDataClientResponse);
begin
  RecebimentosDataset.Close;
  RecebimentosDataset.SetJsonData(Response.Result);
  RecebimentosDataset.Open;
  
  RecebimentosDataset.Edit;  
end;

procedure TFViewRecebimentosEdit.XDataClientRecebimentosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewRecebimentosEdit.XDataClientRecebimentosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewRecebimentosEdit.RecebimentosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewRecebimentosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewRecebimentosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.recebimentos.form.message');
  lbMessage := TLabel.Create('view.recebimentos.form.message.label');
  btCloseMessage := TButton.Create('view.recebimentos.form.message.button');
  btCancel := TButton.Create('view.recebimentos.form.btBack');
  btSave := TButton.Create('view.recebimentos.form.btSave');
  btDelete := TButton.Create('view.recebimentos.form.btDelete');
  lbid := TLabel.Create('view.recebimentos.form.lbid');
  edid := TDBEdit.Create('view.recebimentos.form.edid');
  lbaliado_id := TLabel.Create('view.recebimentos.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.recebimentos.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.recebimentos.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.recebimentos.form.eddata_base_id');
  lbareceber_id := TLabel.Create('view.recebimentos.form.lbareceber_id');
  edareceber_id := TDBEdit.Create('view.recebimentos.form.edareceber_id');
  lbvalor_bruto_recebido := TLabel.Create('view.recebimentos.form.lbvalor_bruto_recebido');
  edvalor_bruto_recebido := TDBEdit.Create('view.recebimentos.form.edvalor_bruto_recebido');
  lbvalor_desconto := TLabel.Create('view.recebimentos.form.lbvalor_desconto');
  edvalor_desconto := TDBEdit.Create('view.recebimentos.form.edvalor_desconto');
  lbvalor_multa := TLabel.Create('view.recebimentos.form.lbvalor_multa');
  edvalor_multa := TDBEdit.Create('view.recebimentos.form.edvalor_multa');
  lbvalor_juros := TLabel.Create('view.recebimentos.form.lbvalor_juros');
  edvalor_juros := TDBEdit.Create('view.recebimentos.form.edvalor_juros');
  lbvalor_outros := TLabel.Create('view.recebimentos.form.lbvalor_outros');
  edvalor_outros := TDBEdit.Create('view.recebimentos.form.edvalor_outros');
  lbdata_recebimento := TLabel.Create('view.recebimentos.form.lbdata_recebimento');
  eddata_recebimento := TDBEdit.Create('view.recebimentos.form.eddata_recebimento');
  lbplano_contas_id := TLabel.Create('view.recebimentos.form.lbplano_contas_id');
  edplano_contas_id := TDBEdit.Create('view.recebimentos.form.edplano_contas_id');
  lbconta_id := TLabel.Create('view.recebimentos.form.lbconta_id');
  edconta_id := TDBEdit.Create('view.recebimentos.form.edconta_id');
  lbmodalidade_id := TLabel.Create('view.recebimentos.form.lbmodalidade_id');
  edmodalidade_id := TDBEdit.Create('view.recebimentos.form.edmodalidade_id');
  lbfuncionario_id := TLabel.Create('view.recebimentos.form.lbfuncionario_id');
  edfuncionario_id := TDBEdit.Create('view.recebimentos.form.edfuncionario_id');
  lbtitulo_cobranca_id := TLabel.Create('view.recebimentos.form.lbtitulo_cobranca_id');
  edtitulo_cobranca_id := TDBEdit.Create('view.recebimentos.form.edtitulo_cobranca_id');
  lbrecebimento_via_banco := TLabel.Create('view.recebimentos.form.lbrecebimento_via_banco');
  edrecebimento_via_banco := TDBEdit.Create('view.recebimentos.form.edrecebimento_via_banco');
  lbrecebimento_venda_aprazo := TLabel.Create('view.recebimentos.form.lbrecebimento_venda_aprazo');
  edrecebimento_venda_aprazo := TDBEdit.Create('view.recebimentos.form.edrecebimento_venda_aprazo');
  lbcodigo_interno := TLabel.Create('view.recebimentos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.recebimentos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.recebimentos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.recebimentos.form.edexcluido');
  lbinclusao := TLabel.Create('view.recebimentos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.recebimentos.form.edinclusao');
  lbalteracao := TLabel.Create('view.recebimentos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.recebimentos.form.edalteracao');
  lbexclusao := TLabel.Create('view.recebimentos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.recebimentos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  RecebimentosDataset := TXDataWebDataSet.Create(Self);
  RecebimentosDatasetid := TIntegerField.Create(Self);
  RecebimentosDatasetaliado_id := TIntegerField.Create(Self);
  RecebimentosDatasetdata_base_id := TIntegerField.Create(Self);
  RecebimentosDatasetareceber_id := TIntegerField.Create(Self);
  RecebimentosDatasetvalor_bruto_recebido := TFloatField.Create(Self);
  RecebimentosDatasetvalor_desconto := TFloatField.Create(Self);
  RecebimentosDatasetvalor_multa := TFloatField.Create(Self);
  RecebimentosDatasetvalor_juros := TFloatField.Create(Self);
  RecebimentosDatasetvalor_outros := TFloatField.Create(Self);
  RecebimentosDatasetdata_recebimento := TDateTimeField.Create(Self);
  RecebimentosDatasetplano_contas_id := TIntegerField.Create(Self);
  RecebimentosDatasetconta_id := TIntegerField.Create(Self);
  RecebimentosDatasetmodalidade_id := TIntegerField.Create(Self);
  RecebimentosDatasetfuncionario_id := TIntegerField.Create(Self);
  RecebimentosDatasettitulo_cobranca_id := TIntegerField.Create(Self);
  RecebimentosDatasetrecebimento_via_banco := TBooleanField.Create(Self);
  RecebimentosDatasetrecebimento_venda_aprazo := TBooleanField.Create(Self);
  RecebimentosDatasetcodigo_interno := TIntegerField.Create(Self);
  RecebimentosDatasetexcluido := TBooleanField.Create(Self);
  RecebimentosDatasetinclusao := TDateTimeField.Create(Self);
  RecebimentosDatasetalteracao := TDateTimeField.Create(Self);
  RecebimentosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientRecebimentosGet := TXDataWebClient.Create(Self);
  XDataClientRecebimentosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbareceber_id.BeforeLoadDFMValues;
  edareceber_id.BeforeLoadDFMValues;
  lbvalor_bruto_recebido.BeforeLoadDFMValues;
  edvalor_bruto_recebido.BeforeLoadDFMValues;
  lbvalor_desconto.BeforeLoadDFMValues;
  edvalor_desconto.BeforeLoadDFMValues;
  lbvalor_multa.BeforeLoadDFMValues;
  edvalor_multa.BeforeLoadDFMValues;
  lbvalor_juros.BeforeLoadDFMValues;
  edvalor_juros.BeforeLoadDFMValues;
  lbvalor_outros.BeforeLoadDFMValues;
  edvalor_outros.BeforeLoadDFMValues;
  lbdata_recebimento.BeforeLoadDFMValues;
  eddata_recebimento.BeforeLoadDFMValues;
  lbplano_contas_id.BeforeLoadDFMValues;
  edplano_contas_id.BeforeLoadDFMValues;
  lbconta_id.BeforeLoadDFMValues;
  edconta_id.BeforeLoadDFMValues;
  lbmodalidade_id.BeforeLoadDFMValues;
  edmodalidade_id.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  lbtitulo_cobranca_id.BeforeLoadDFMValues;
  edtitulo_cobranca_id.BeforeLoadDFMValues;
  lbrecebimento_via_banco.BeforeLoadDFMValues;
  edrecebimento_via_banco.BeforeLoadDFMValues;
  lbrecebimento_venda_aprazo.BeforeLoadDFMValues;
  edrecebimento_venda_aprazo.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  RecebimentosDataset.BeforeLoadDFMValues;
  RecebimentosDatasetid.BeforeLoadDFMValues;
  RecebimentosDatasetaliado_id.BeforeLoadDFMValues;
  RecebimentosDatasetdata_base_id.BeforeLoadDFMValues;
  RecebimentosDatasetareceber_id.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_bruto_recebido.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_desconto.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_multa.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_juros.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_outros.BeforeLoadDFMValues;
  RecebimentosDatasetdata_recebimento.BeforeLoadDFMValues;
  RecebimentosDatasetplano_contas_id.BeforeLoadDFMValues;
  RecebimentosDatasetconta_id.BeforeLoadDFMValues;
  RecebimentosDatasetmodalidade_id.BeforeLoadDFMValues;
  RecebimentosDatasetfuncionario_id.BeforeLoadDFMValues;
  RecebimentosDatasettitulo_cobranca_id.BeforeLoadDFMValues;
  RecebimentosDatasetrecebimento_via_banco.BeforeLoadDFMValues;
  RecebimentosDatasetrecebimento_venda_aprazo.BeforeLoadDFMValues;
  RecebimentosDatasetcodigo_interno.BeforeLoadDFMValues;
  RecebimentosDatasetexcluido.BeforeLoadDFMValues;
  RecebimentosDatasetinclusao.BeforeLoadDFMValues;
  RecebimentosDatasetalteracao.BeforeLoadDFMValues;
  RecebimentosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientRecebimentosGet.BeforeLoadDFMValues;
  XDataClientRecebimentosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewRecebimentosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 859;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 799;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 799;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 799;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbareceber_id.SetParentComponent(Self);
    lbareceber_id.Name := 'lbareceber_id';
    lbareceber_id.Left := 24;
    lbareceber_id.Top := 273;
    lbareceber_id.Width := 14;
    lbareceber_id.Height := 13;
    lbareceber_id.Caption := 'areceber_id:';
    lbareceber_id.Transparent := True;
    edareceber_id.SetParentComponent(Self);
    edareceber_id.Name := 'edareceber_id';
    edareceber_id.Left := 221;
    edareceber_id.Top := 270;
    edareceber_id.Width := 200;
    edareceber_id.Height := 21;
    edareceber_id.Enabled := True;
    edareceber_id.TabOrder := 9;
    edareceber_id.Text := 'edareceber_id';
    edareceber_id.DataField := 'areceber_id';
    edareceber_id.DataSource := DataSource;
    lbvalor_bruto_recebido.SetParentComponent(Self);
    lbvalor_bruto_recebido.Name := 'lbvalor_bruto_recebido';
    lbvalor_bruto_recebido.Left := 24;
    lbvalor_bruto_recebido.Top := 300;
    lbvalor_bruto_recebido.Width := 14;
    lbvalor_bruto_recebido.Height := 13;
    lbvalor_bruto_recebido.Caption := 'valor_bruto_recebido:';
    lbvalor_bruto_recebido.Transparent := True;
    edvalor_bruto_recebido.SetParentComponent(Self);
    edvalor_bruto_recebido.Name := 'edvalor_bruto_recebido';
    edvalor_bruto_recebido.Left := 221;
    edvalor_bruto_recebido.Top := 297;
    edvalor_bruto_recebido.Width := 200;
    edvalor_bruto_recebido.Height := 21;
    edvalor_bruto_recebido.Enabled := True;
    edvalor_bruto_recebido.TabOrder := 10;
    edvalor_bruto_recebido.Text := 'edvalor_bruto_recebido';
    edvalor_bruto_recebido.DataField := 'valor_bruto_recebido';
    edvalor_bruto_recebido.DataSource := DataSource;
    lbvalor_desconto.SetParentComponent(Self);
    lbvalor_desconto.Name := 'lbvalor_desconto';
    lbvalor_desconto.Left := 24;
    lbvalor_desconto.Top := 327;
    lbvalor_desconto.Width := 14;
    lbvalor_desconto.Height := 13;
    lbvalor_desconto.Caption := 'valor_desconto:';
    lbvalor_desconto.Transparent := True;
    edvalor_desconto.SetParentComponent(Self);
    edvalor_desconto.Name := 'edvalor_desconto';
    edvalor_desconto.Left := 221;
    edvalor_desconto.Top := 324;
    edvalor_desconto.Width := 200;
    edvalor_desconto.Height := 21;
    edvalor_desconto.Enabled := True;
    edvalor_desconto.TabOrder := 11;
    edvalor_desconto.Text := 'edvalor_desconto';
    edvalor_desconto.DataField := 'valor_desconto';
    edvalor_desconto.DataSource := DataSource;
    lbvalor_multa.SetParentComponent(Self);
    lbvalor_multa.Name := 'lbvalor_multa';
    lbvalor_multa.Left := 24;
    lbvalor_multa.Top := 354;
    lbvalor_multa.Width := 14;
    lbvalor_multa.Height := 13;
    lbvalor_multa.Caption := 'valor_multa:';
    lbvalor_multa.Transparent := True;
    edvalor_multa.SetParentComponent(Self);
    edvalor_multa.Name := 'edvalor_multa';
    edvalor_multa.Left := 221;
    edvalor_multa.Top := 351;
    edvalor_multa.Width := 200;
    edvalor_multa.Height := 21;
    edvalor_multa.Enabled := True;
    edvalor_multa.TabOrder := 12;
    edvalor_multa.Text := 'edvalor_multa';
    edvalor_multa.DataField := 'valor_multa';
    edvalor_multa.DataSource := DataSource;
    lbvalor_juros.SetParentComponent(Self);
    lbvalor_juros.Name := 'lbvalor_juros';
    lbvalor_juros.Left := 24;
    lbvalor_juros.Top := 381;
    lbvalor_juros.Width := 14;
    lbvalor_juros.Height := 13;
    lbvalor_juros.Caption := 'valor_juros:';
    lbvalor_juros.Transparent := True;
    edvalor_juros.SetParentComponent(Self);
    edvalor_juros.Name := 'edvalor_juros';
    edvalor_juros.Left := 221;
    edvalor_juros.Top := 378;
    edvalor_juros.Width := 200;
    edvalor_juros.Height := 21;
    edvalor_juros.Enabled := True;
    edvalor_juros.TabOrder := 13;
    edvalor_juros.Text := 'edvalor_juros';
    edvalor_juros.DataField := 'valor_juros';
    edvalor_juros.DataSource := DataSource;
    lbvalor_outros.SetParentComponent(Self);
    lbvalor_outros.Name := 'lbvalor_outros';
    lbvalor_outros.Left := 24;
    lbvalor_outros.Top := 408;
    lbvalor_outros.Width := 14;
    lbvalor_outros.Height := 13;
    lbvalor_outros.Caption := 'valor_outros:';
    lbvalor_outros.Transparent := True;
    edvalor_outros.SetParentComponent(Self);
    edvalor_outros.Name := 'edvalor_outros';
    edvalor_outros.Left := 221;
    edvalor_outros.Top := 405;
    edvalor_outros.Width := 200;
    edvalor_outros.Height := 21;
    edvalor_outros.Enabled := True;
    edvalor_outros.TabOrder := 14;
    edvalor_outros.Text := 'edvalor_outros';
    edvalor_outros.DataField := 'valor_outros';
    edvalor_outros.DataSource := DataSource;
    lbdata_recebimento.SetParentComponent(Self);
    lbdata_recebimento.Name := 'lbdata_recebimento';
    lbdata_recebimento.Left := 24;
    lbdata_recebimento.Top := 435;
    lbdata_recebimento.Width := 14;
    lbdata_recebimento.Height := 13;
    lbdata_recebimento.Caption := 'data_recebimento:';
    lbdata_recebimento.Transparent := True;
    eddata_recebimento.SetParentComponent(Self);
    eddata_recebimento.Name := 'eddata_recebimento';
    eddata_recebimento.Left := 221;
    eddata_recebimento.Top := 432;
    eddata_recebimento.Width := 200;
    eddata_recebimento.Height := 21;
    eddata_recebimento.Enabled := True;
    eddata_recebimento.TabOrder := 15;
    eddata_recebimento.Text := 'eddata_recebimento';
    eddata_recebimento.DataField := 'data_recebimento';
    eddata_recebimento.DataSource := DataSource;
    lbplano_contas_id.SetParentComponent(Self);
    lbplano_contas_id.Name := 'lbplano_contas_id';
    lbplano_contas_id.Left := 24;
    lbplano_contas_id.Top := 462;
    lbplano_contas_id.Width := 14;
    lbplano_contas_id.Height := 13;
    lbplano_contas_id.Caption := 'plano_contas_id:';
    lbplano_contas_id.Transparent := True;
    edplano_contas_id.SetParentComponent(Self);
    edplano_contas_id.Name := 'edplano_contas_id';
    edplano_contas_id.Left := 221;
    edplano_contas_id.Top := 459;
    edplano_contas_id.Width := 200;
    edplano_contas_id.Height := 21;
    edplano_contas_id.Enabled := True;
    edplano_contas_id.TabOrder := 16;
    edplano_contas_id.Text := 'edplano_contas_id';
    edplano_contas_id.DataField := 'plano_contas_id';
    edplano_contas_id.DataSource := DataSource;
    lbconta_id.SetParentComponent(Self);
    lbconta_id.Name := 'lbconta_id';
    lbconta_id.Left := 24;
    lbconta_id.Top := 489;
    lbconta_id.Width := 14;
    lbconta_id.Height := 13;
    lbconta_id.Caption := 'conta_id:';
    lbconta_id.Transparent := True;
    edconta_id.SetParentComponent(Self);
    edconta_id.Name := 'edconta_id';
    edconta_id.Left := 221;
    edconta_id.Top := 486;
    edconta_id.Width := 200;
    edconta_id.Height := 21;
    edconta_id.Enabled := True;
    edconta_id.TabOrder := 17;
    edconta_id.Text := 'edconta_id';
    edconta_id.DataField := 'conta_id';
    edconta_id.DataSource := DataSource;
    lbmodalidade_id.SetParentComponent(Self);
    lbmodalidade_id.Name := 'lbmodalidade_id';
    lbmodalidade_id.Left := 24;
    lbmodalidade_id.Top := 516;
    lbmodalidade_id.Width := 14;
    lbmodalidade_id.Height := 13;
    lbmodalidade_id.Caption := 'modalidade_id:';
    lbmodalidade_id.Transparent := True;
    edmodalidade_id.SetParentComponent(Self);
    edmodalidade_id.Name := 'edmodalidade_id';
    edmodalidade_id.Left := 221;
    edmodalidade_id.Top := 513;
    edmodalidade_id.Width := 200;
    edmodalidade_id.Height := 21;
    edmodalidade_id.Enabled := True;
    edmodalidade_id.TabOrder := 18;
    edmodalidade_id.Text := 'edmodalidade_id';
    edmodalidade_id.DataField := 'modalidade_id';
    edmodalidade_id.DataSource := DataSource;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 24;
    lbfuncionario_id.Top := 543;
    lbfuncionario_id.Width := 14;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'funcionario_id:';
    lbfuncionario_id.Transparent := True;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 221;
    edfuncionario_id.Top := 540;
    edfuncionario_id.Width := 200;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := True;
    edfuncionario_id.TabOrder := 19;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.DataField := 'funcionario_id';
    edfuncionario_id.DataSource := DataSource;
    lbtitulo_cobranca_id.SetParentComponent(Self);
    lbtitulo_cobranca_id.Name := 'lbtitulo_cobranca_id';
    lbtitulo_cobranca_id.Left := 24;
    lbtitulo_cobranca_id.Top := 570;
    lbtitulo_cobranca_id.Width := 14;
    lbtitulo_cobranca_id.Height := 13;
    lbtitulo_cobranca_id.Caption := 'titulo_cobranca_id:';
    lbtitulo_cobranca_id.Transparent := True;
    edtitulo_cobranca_id.SetParentComponent(Self);
    edtitulo_cobranca_id.Name := 'edtitulo_cobranca_id';
    edtitulo_cobranca_id.Left := 221;
    edtitulo_cobranca_id.Top := 567;
    edtitulo_cobranca_id.Width := 200;
    edtitulo_cobranca_id.Height := 21;
    edtitulo_cobranca_id.Enabled := True;
    edtitulo_cobranca_id.TabOrder := 20;
    edtitulo_cobranca_id.Text := 'edtitulo_cobranca_id';
    edtitulo_cobranca_id.DataField := 'titulo_cobranca_id';
    edtitulo_cobranca_id.DataSource := DataSource;
    lbrecebimento_via_banco.SetParentComponent(Self);
    lbrecebimento_via_banco.Name := 'lbrecebimento_via_banco';
    lbrecebimento_via_banco.Left := 24;
    lbrecebimento_via_banco.Top := 597;
    lbrecebimento_via_banco.Width := 14;
    lbrecebimento_via_banco.Height := 13;
    lbrecebimento_via_banco.Caption := 'recebimento_via_banco:';
    lbrecebimento_via_banco.Transparent := True;
    edrecebimento_via_banco.SetParentComponent(Self);
    edrecebimento_via_banco.Name := 'edrecebimento_via_banco';
    edrecebimento_via_banco.Left := 221;
    edrecebimento_via_banco.Top := 594;
    edrecebimento_via_banco.Width := 200;
    edrecebimento_via_banco.Height := 21;
    edrecebimento_via_banco.Enabled := True;
    edrecebimento_via_banco.TabOrder := 21;
    edrecebimento_via_banco.Text := 'edrecebimento_via_banco';
    edrecebimento_via_banco.DataField := 'recebimento_via_banco';
    edrecebimento_via_banco.DataSource := DataSource;
    lbrecebimento_venda_aprazo.SetParentComponent(Self);
    lbrecebimento_venda_aprazo.Name := 'lbrecebimento_venda_aprazo';
    lbrecebimento_venda_aprazo.Left := 24;
    lbrecebimento_venda_aprazo.Top := 624;
    lbrecebimento_venda_aprazo.Width := 14;
    lbrecebimento_venda_aprazo.Height := 13;
    lbrecebimento_venda_aprazo.Caption := 'recebimento_venda_aprazo:';
    lbrecebimento_venda_aprazo.Transparent := True;
    edrecebimento_venda_aprazo.SetParentComponent(Self);
    edrecebimento_venda_aprazo.Name := 'edrecebimento_venda_aprazo';
    edrecebimento_venda_aprazo.Left := 221;
    edrecebimento_venda_aprazo.Top := 621;
    edrecebimento_venda_aprazo.Width := 200;
    edrecebimento_venda_aprazo.Height := 21;
    edrecebimento_venda_aprazo.Enabled := True;
    edrecebimento_venda_aprazo.TabOrder := 22;
    edrecebimento_venda_aprazo.Text := 'edrecebimento_venda_aprazo';
    edrecebimento_venda_aprazo.DataField := 'recebimento_venda_aprazo';
    edrecebimento_venda_aprazo.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 651;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 648;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 23;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 678;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 675;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 24;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 705;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 702;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 25;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 732;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 729;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 26;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 759;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 756;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 27;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := RecebimentosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    RecebimentosDataset.SetParentComponent(Self);
    RecebimentosDataset.Name := 'RecebimentosDataset';
    RecebimentosDataset.AfterApplyUpdates := RecebimentosDatasetAfterApplyUpdates;
    RecebimentosDataset.EntitySetName := 'Recebimentos';
    RecebimentosDataset.Connection := DMConnection.ApiConnection;
    RecebimentosDataset.Left := 176;
    RecebimentosDataset.Top := 8;
    RecebimentosDatasetid.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetid.Name := 'RecebimentosDatasetid';
    RecebimentosDatasetid.FieldName := 'id';
    RecebimentosDatasetid.Required := True;
    RecebimentosDatasetaliado_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetaliado_id.Name := 'RecebimentosDatasetaliado_id';
    RecebimentosDatasetaliado_id.FieldName := 'aliado_id';
    RecebimentosDatasetaliado_id.Required := True;
    RecebimentosDatasetdata_base_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetdata_base_id.Name := 'RecebimentosDatasetdata_base_id';
    RecebimentosDatasetdata_base_id.FieldName := 'data_base_id';
    RecebimentosDatasetdata_base_id.Required := True;
    RecebimentosDatasetareceber_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetareceber_id.Name := 'RecebimentosDatasetareceber_id';
    RecebimentosDatasetareceber_id.FieldName := 'areceber_id';
    RecebimentosDatasetareceber_id.Required := True;
    RecebimentosDatasetvalor_bruto_recebido.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_bruto_recebido.Name := 'RecebimentosDatasetvalor_bruto_recebido';
    RecebimentosDatasetvalor_bruto_recebido.FieldName := 'valor_bruto_recebido';
    RecebimentosDatasetvalor_bruto_recebido.Required := False;
    RecebimentosDatasetvalor_desconto.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_desconto.Name := 'RecebimentosDatasetvalor_desconto';
    RecebimentosDatasetvalor_desconto.FieldName := 'valor_desconto';
    RecebimentosDatasetvalor_desconto.Required := False;
    RecebimentosDatasetvalor_multa.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_multa.Name := 'RecebimentosDatasetvalor_multa';
    RecebimentosDatasetvalor_multa.FieldName := 'valor_multa';
    RecebimentosDatasetvalor_multa.Required := False;
    RecebimentosDatasetvalor_juros.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_juros.Name := 'RecebimentosDatasetvalor_juros';
    RecebimentosDatasetvalor_juros.FieldName := 'valor_juros';
    RecebimentosDatasetvalor_juros.Required := False;
    RecebimentosDatasetvalor_outros.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_outros.Name := 'RecebimentosDatasetvalor_outros';
    RecebimentosDatasetvalor_outros.FieldName := 'valor_outros';
    RecebimentosDatasetvalor_outros.Required := False;
    RecebimentosDatasetdata_recebimento.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetdata_recebimento.Name := 'RecebimentosDatasetdata_recebimento';
    RecebimentosDatasetdata_recebimento.FieldName := 'data_recebimento';
    RecebimentosDatasetdata_recebimento.Required := False;
    RecebimentosDatasetplano_contas_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetplano_contas_id.Name := 'RecebimentosDatasetplano_contas_id';
    RecebimentosDatasetplano_contas_id.FieldName := 'plano_contas_id';
    RecebimentosDatasetplano_contas_id.Required := False;
    RecebimentosDatasetconta_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetconta_id.Name := 'RecebimentosDatasetconta_id';
    RecebimentosDatasetconta_id.FieldName := 'conta_id';
    RecebimentosDatasetconta_id.Required := False;
    RecebimentosDatasetmodalidade_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetmodalidade_id.Name := 'RecebimentosDatasetmodalidade_id';
    RecebimentosDatasetmodalidade_id.FieldName := 'modalidade_id';
    RecebimentosDatasetmodalidade_id.Required := False;
    RecebimentosDatasetfuncionario_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetfuncionario_id.Name := 'RecebimentosDatasetfuncionario_id';
    RecebimentosDatasetfuncionario_id.FieldName := 'funcionario_id';
    RecebimentosDatasetfuncionario_id.Required := False;
    RecebimentosDatasettitulo_cobranca_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasettitulo_cobranca_id.Name := 'RecebimentosDatasettitulo_cobranca_id';
    RecebimentosDatasettitulo_cobranca_id.FieldName := 'titulo_cobranca_id';
    RecebimentosDatasettitulo_cobranca_id.Required := False;
    RecebimentosDatasetrecebimento_via_banco.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetrecebimento_via_banco.Name := 'RecebimentosDatasetrecebimento_via_banco';
    RecebimentosDatasetrecebimento_via_banco.FieldName := 'recebimento_via_banco';
    RecebimentosDatasetrecebimento_via_banco.Required := True;
    RecebimentosDatasetrecebimento_venda_aprazo.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetrecebimento_venda_aprazo.Name := 'RecebimentosDatasetrecebimento_venda_aprazo';
    RecebimentosDatasetrecebimento_venda_aprazo.FieldName := 'recebimento_venda_aprazo';
    RecebimentosDatasetrecebimento_venda_aprazo.Required := True;
    RecebimentosDatasetcodigo_interno.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetcodigo_interno.Name := 'RecebimentosDatasetcodigo_interno';
    RecebimentosDatasetcodigo_interno.FieldName := 'codigo_interno';
    RecebimentosDatasetcodigo_interno.Required := True;
    RecebimentosDatasetexcluido.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetexcluido.Name := 'RecebimentosDatasetexcluido';
    RecebimentosDatasetexcluido.FieldName := 'excluido';
    RecebimentosDatasetexcluido.Required := False;
    RecebimentosDatasetinclusao.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetinclusao.Name := 'RecebimentosDatasetinclusao';
    RecebimentosDatasetinclusao.FieldName := 'inclusao';
    RecebimentosDatasetinclusao.Required := False;
    RecebimentosDatasetalteracao.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetalteracao.Name := 'RecebimentosDatasetalteracao';
    RecebimentosDatasetalteracao.FieldName := 'alteracao';
    RecebimentosDatasetalteracao.Required := False;
    RecebimentosDatasetexclusao.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetexclusao.Name := 'RecebimentosDatasetexclusao';
    RecebimentosDatasetexclusao.FieldName := 'exclusao';
    RecebimentosDatasetexclusao.Required := False;
    XDataClientRecebimentosGet.SetParentComponent(Self);
    XDataClientRecebimentosGet.Name := 'XDataClientRecebimentosGet';
    XDataClientRecebimentosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientRecebimentosGet, Self, 'OnLoad', 'XDataClientRecebimentosGetLoad');
    XDataClientRecebimentosGet.Left := 64;
    XDataClientRecebimentosGet.Top := 8;
    XDataClientRecebimentosDelete.SetParentComponent(Self);
    XDataClientRecebimentosDelete.Name := 'XDataClientRecebimentosDelete';
    XDataClientRecebimentosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientRecebimentosDelete, Self, 'OnLoad', 'XDataClientRecebimentosDeleteLoad');
    SetEvent(XDataClientRecebimentosDelete, Self, 'OnError', 'XDataClientRecebimentosDeleteError');
    XDataClientRecebimentosDelete.Left := 64;
    XDataClientRecebimentosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbareceber_id.AfterLoadDFMValues;
    edareceber_id.AfterLoadDFMValues;
    lbvalor_bruto_recebido.AfterLoadDFMValues;
    edvalor_bruto_recebido.AfterLoadDFMValues;
    lbvalor_desconto.AfterLoadDFMValues;
    edvalor_desconto.AfterLoadDFMValues;
    lbvalor_multa.AfterLoadDFMValues;
    edvalor_multa.AfterLoadDFMValues;
    lbvalor_juros.AfterLoadDFMValues;
    edvalor_juros.AfterLoadDFMValues;
    lbvalor_outros.AfterLoadDFMValues;
    edvalor_outros.AfterLoadDFMValues;
    lbdata_recebimento.AfterLoadDFMValues;
    eddata_recebimento.AfterLoadDFMValues;
    lbplano_contas_id.AfterLoadDFMValues;
    edplano_contas_id.AfterLoadDFMValues;
    lbconta_id.AfterLoadDFMValues;
    edconta_id.AfterLoadDFMValues;
    lbmodalidade_id.AfterLoadDFMValues;
    edmodalidade_id.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    lbtitulo_cobranca_id.AfterLoadDFMValues;
    edtitulo_cobranca_id.AfterLoadDFMValues;
    lbrecebimento_via_banco.AfterLoadDFMValues;
    edrecebimento_via_banco.AfterLoadDFMValues;
    lbrecebimento_venda_aprazo.AfterLoadDFMValues;
    edrecebimento_venda_aprazo.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    RecebimentosDataset.AfterLoadDFMValues;
    RecebimentosDatasetid.AfterLoadDFMValues;
    RecebimentosDatasetaliado_id.AfterLoadDFMValues;
    RecebimentosDatasetdata_base_id.AfterLoadDFMValues;
    RecebimentosDatasetareceber_id.AfterLoadDFMValues;
    RecebimentosDatasetvalor_bruto_recebido.AfterLoadDFMValues;
    RecebimentosDatasetvalor_desconto.AfterLoadDFMValues;
    RecebimentosDatasetvalor_multa.AfterLoadDFMValues;
    RecebimentosDatasetvalor_juros.AfterLoadDFMValues;
    RecebimentosDatasetvalor_outros.AfterLoadDFMValues;
    RecebimentosDatasetdata_recebimento.AfterLoadDFMValues;
    RecebimentosDatasetplano_contas_id.AfterLoadDFMValues;
    RecebimentosDatasetconta_id.AfterLoadDFMValues;
    RecebimentosDatasetmodalidade_id.AfterLoadDFMValues;
    RecebimentosDatasetfuncionario_id.AfterLoadDFMValues;
    RecebimentosDatasettitulo_cobranca_id.AfterLoadDFMValues;
    RecebimentosDatasetrecebimento_via_banco.AfterLoadDFMValues;
    RecebimentosDatasetrecebimento_venda_aprazo.AfterLoadDFMValues;
    RecebimentosDatasetcodigo_interno.AfterLoadDFMValues;
    RecebimentosDatasetexcluido.AfterLoadDFMValues;
    RecebimentosDatasetinclusao.AfterLoadDFMValues;
    RecebimentosDatasetalteracao.AfterLoadDFMValues;
    RecebimentosDatasetexclusao.AfterLoadDFMValues;
    XDataClientRecebimentosGet.AfterLoadDFMValues;
    XDataClientRecebimentosDelete.AfterLoadDFMValues;
  end;
end;

end.
